export const PROFILE_ID_LENGTH = 12;

export function canonicalizeProfileId(raw: string | number | null | undefined): string {
  if (raw === null || raw === undefined) {
    return "";
  }
  const value = String(raw).trim();
  if (/^-?\d+$/.test(value)) {
    return value;
  }
  return value.toUpperCase();
}

export function isProfileId(raw: string | number | null | undefined): boolean {
  return canonicalizeProfileId(raw).length > 0;
}
